export default {
    ADDRESS: 'geocode',
    BUSINESS: 'establishment',
};
